/**
 * Unauthorized Page - shown when user doesn't have required permissions
 */

import { Link } from 'react-router-dom'
import { ShieldX, ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function UnauthorizedPage(): React.ReactElement {
  const { t } = useTranslation('errors')

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-4 dark:bg-stone-950">
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          <ShieldX className="h-10 w-10 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-2xl font-semibold text-stone-900 dark:text-stone-100">
          {t('unauthorized.title')}
        </h1>
        <p className="mt-2 max-w-md text-stone-600 dark:text-stone-400">
          {t('unauthorized.message')}
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 rounded-lg bg-lime-500 px-4 py-2 font-medium text-stone-900 transition-colors hover:bg-lime-400"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('unauthorized.backToDashboard')}
          </Link>
        </div>
      </div>
    </div>
  )
}
